import { render, staticRenderFns } from "./HuchaAgregarIban.vue?vue&type=template&id=2e459dc5&scoped=true"
import script from "./HuchaAgregarIban.vue?vue&type=script&lang=js"
export * from "./HuchaAgregarIban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e459dc5",
  null
  
)

export default component.exports